class UnitPayload {
  constructor() {
    this.unitName = '';
    this.status = '';
    this.active = '';
    this.topics = [];
    this.topicsCount = 0;
    this.subTopics = [];
    this.subTopicsCount = 0;
    this.completion = '';
  }
}

class SubjectPayload {
  constructor() {
    this.title = '';
    this.subtitle = '';
    this.subjectName = '';
    this.totalTopics = 0;
    this.totalSubTopics = 0;
    this.totalVideoTime = 0;
    this.totalUnitVideoTime = 0;
    this.totalUnitsCount = 0;
    this.units = [];
  }
}

class TopicPayload {
  constructor() {
    this.unitName = '';
    this.unitId = '';
    this.totalSubTopics = 0;
    this.totalVideoTime = 0;
    this.totalTrialSubTopics = 0;
    this.totalTrialVideoTime = 0;
  }
}

export { UnitPayload, SubjectPayload, TopicPayload };
